import * as React from "react";

function untyped(component: any): React.ComponentClass<any> {
  return component as React.ComponentClass<any>;
}

export { untyped };
